import type { ActionFormationDTO, LovAfDTO } from '@/features/api/extranet/dto/Demande/AF'
import { afService } from '@/features/services/demande'
import { buildDemandeStore } from '../shared'
import { propertyStatusConfiguration, reglesConfiguration } from '@/features/domaine/regles-akto/AF'

export const useDemandeAFStore = buildDemandeStore<ActionFormationDTO, LovAfDTO>({
  dispositif: 'AF',
  demandeService: afService,
  propertyStatusConfiguration,
  reglesConfiguration,
})
